module.exports = __webpack_public_path__ + "static/media/0_2019_02_19.4fe1a914.jpg";